/**
 * @class ImageBanner
 * @classdesc Primarily responsible for handling situations where the section content
 * is larger than the defined setting value
 * @extends Core.SectionComponent
 */
export default class ImageBanner extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);
    this.contentEl = el.querySelector('[data-image-banner-content]');
    this.wrapper = el.querySelector('[data-image-banner-wrapper]');
    this.imageContainers = el.querySelectorAll('[data-image-banner-image]');
    this.desktopHeight = this.data.desktopHeight;
    this._resizeFunc = this._adjustSectionHeight.bind(this);

    Core.Breakpoints.onChange(this._resizeFunc);
  }

  onMount() {
    this._adjustSectionHeight();
  }

  onDismount() {
    super.onDismount();
    Core.Breakpoints.offChange(this._resizeFunc);
  }

  /**
   * Sets CSS Custom Properties based on content height.
   * When desktop height is set to 'adapt to height of first image', the height of the image
   * is used to determine whether the content will fit inside without overflow.
   * Otherwise, the pixel value of the setting is used as the comparison.
   */
  _adjustSectionHeight() {
    if (!this.contentEl) return;

    const visibleImageContainer = [...this.imageContainers]
      .filter(img => img.offsetParent !== null);
    const visibleImage = visibleImageContainer[0].querySelector('img') !== null
      ? visibleImageContainer[0].querySelector('img')
      : visibleImageContainer[0].querySelector('svg');

    const { offsetHeight: imageHeight } = visibleImage;
    const { innerHeight: mobileHeight } = window;
    const { paddingTop: containerPaddingTop } = getComputedStyle(this.contentEl);
    const paddingTopInt = Number(containerPaddingTop.replace('px', ''));
    const totalContainerHeight = [...this.contentEl.children]
      .reduce((acc, curr) => acc + curr.offsetHeight, paddingTopInt * 2);

    const valueToCompare = this.desktopHeight === 'adapt'
      ? imageHeight
      : Number(this.desktopHeight);

    if (Core.Breakpoints.min('S') && valueToCompare < totalContainerHeight) {
      this.wrapper.style.setProperty('--desktop-height', `${totalContainerHeight}px`);
    }

    if (mobileHeight < totalContainerHeight) {
      this.wrapper.style.setProperty('--mobile-height', `${totalContainerHeight}px`);
    }
  }
}
